<template>
  <div class="input-token">
    <h2>Digite o token de validação:</h2>
    <form class="input-token__form">
      <input
        id="token"
        v-model="token"
        type="text"
        name="Token"
        title="Token"
        placeholder="Token"
        required
      />
      <button @click.prevent="goToValidateToken">Validar</button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

if (!Vue.prototype.$recaptchaLoaded) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA_SITE_KEY,
    loaderOptions: {
      useEnterprise: true,
    },
  })
}

export default {
  name: 'InputToken',
  data() {
    return {
      token: '',
      loading: false,
    }
  },
  methods: {
    async goToValidateToken() {
      if (this.token && !this.loading) {
        this.loading = true
        try {
          await this.$recaptchaLoaded()
          const recaptchaToken = await this.$recaptcha('validate_token')
          this.$router.replace({
            path: `/valida/token/s/${this.token}`,
            query: { recaptcha: recaptchaToken },
          })
          this.$recaptchaInstance.hideBadge()
        } catch (error) {
          this.$router.replace(`/valida/token/s/${this.token}`)
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
.input-token {
  max-width: 380px;
  margin: 0 auto;

  &__form {
    display: flex;
    flex-direction: column;

    #token {
      text-align: center;
      font-size: 14px;
      height: 45px;
      background: transparent;
      background-color: #efeeee;
      margin-top: 18px;
      border: none;
      border-bottom: 2px solid rgba(75, 75, 75, 0.4);
      border-radius: 4px 4px 0 0;
      font-family: 'Exo 2', sans-serif !important;
      outline: none;
    }

    button {
      background-color: #7f1a54;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      width: 100px;
      margin: 45px auto 0;
    }
  }
}
</style>
